import React from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { CheckCircle as CompletedIcon } from '@mui/icons-material';
import './Dashboard.scss';

const MeditationStats = ({ completedMeditations, loading }) => {
  return (
    <Card className="meditation-stats-widget">
      <CardContent>
        <Typography variant="h6" className="widget-title">
          Completed Meditations
        </Typography>
        {loading ? (
          <Box className="loading-container">
            <CircularProgress />
          </Box>
        ) : (
          <Box className="meditation-stats-content">
            <Box className="meditation-stat-item main">
              <CompletedIcon className="stat-icon" fontSize="large" />
              <Box>
                <Typography variant="h3" className="stat-value">
                  {completedMeditations?.total?.toLocaleString() || '0'}
                </Typography>
                <Typography variant="body1" className="stat-label">
                  Total Completions
                </Typography>
              </Box>
            </Box>
            <Box className="meditation-breakdown">
              <Box className="breakdown-item">
                <Typography variant="h6" className="breakdown-value">
                  {completedMeditations?.regular_sessions?.toLocaleString() || '0'}
                </Typography>
                <Typography variant="body2" className="breakdown-label">
                  Regular Sessions
                </Typography>
              </Box>
              <Box className="breakdown-item">
                <Typography variant="h6" className="breakdown-value">
                  {completedMeditations?.quick_tap_sessions?.toLocaleString() || '0'}
                </Typography>
                <Typography variant="body2" className="breakdown-label">
                  Quick Taps
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MeditationStats;
